module.exports = __webpack_public_path__ + "img/index6.b5bf0fd2.webp";